import { fetcher } from '@commenda/utils';
import type { AdminSlackChannelSummary } from './useAdminCompanyExternalConnections';

export interface LinkAdminSlackChannelParams {
  companyId: number;
  slackChannelId: string;
}

export interface LinkAdminSlackChannelResponse {
  success: boolean;
  channel: AdminSlackChannelSummary;
}

export async function linkAdminSlackChannel({
  companyId,
  slackChannelId,
}: LinkAdminSlackChannelParams): Promise<LinkAdminSlackChannelResponse> {
  const response = await fetcher(
    `admin/companies/${companyId}/external-connections/slack/link`,
    {
      method: 'POST',
      body: { slackChannelId },
    }
  );

  if (!response.ok) {
    const body = (await response.json().catch(() => null)) as {
      message?: unknown;
      error?: unknown;
    } | null;
    const message =
      typeof body?.message === 'string'
        ? body.message
        : Array.isArray(body?.message)
          ? body.message.join(', ')
          : typeof body?.error === 'string'
            ? body.error
            : 'Failed to link Slack channel';
    throw new Error(message);
  }

  return response.json();
}
